import React, { createContext, useContext, useEffect } from "react";

// Site is English-only (Turkish version removed on request 2026-08-02).
export const translations = {
  en: {
    nav: { work: "Work", about: "About", contact: "Contact", cta: "Let's Talk" },
    hero: {
      role: "Video Editor & Motion Designer",
      line1: "Polat",
      line2: "Pala",
      tagline: "I cut, animate and choreograph brand-driven stories — social-first, high-impact, made to move.",
      scroll: "Scroll to explore",
      based: "Based worldwide — working remotely",
    },
    marquee: ["Directed by Polat Pala", "Motion Designer", "Video Editor", "Kinetic Typography", "Brand Storytelling"],
    work: {
      label: "Selected Work",
      title: "The Timeline",
      intro: "A curated reel of motion, film and design. Hover to preview, click to play the full cut.",
      filters: { all: "All", motion: "Motion", video: "Video", graphic: "Graphic" },
      play: "Play",
      empty: "No projects in this track yet.",
      clientLabel: "Filtered by",
      clearClient: "Clear",
    },
    about: {
      label: "About",
      title: "The Auteur",
      heading: "About",
      brandsTitle: "Trusted by brands worldwide",
      longBio: [
        "I'm Polat Pala — a creative professional working at the intersection of video editing, motion design, and brand storytelling. I specialize in turning ideas into clear, engaging visual content that connects with people. From concept to final delivery, I enjoy being involved in the full production process and shaping stories that feel both strategic and visually strong.",
        "I've worked on a wide range of digital projects, including social media content, brand videos, and short-form formats, always focusing on clarity, rhythm, and emotional impact.",
        "What motivates me most is building visuals that don't just look good, but communicate something meaningful. I believe strong design and motion should serve a purpose — whether that's telling a brand story, simplifying a message, or creating a memorable experience.",
        "Open to new collaborations, creative challenges, and roles where I can grow while creating impactful work.",
      ],
      reachLine: "Feel free to reach out if you'd like to collaborate or just exchange ideas.",
      manifesto: [
        { n: "01", h: "Rhythm is everything", t: "An edit lives or dies on its timing. I cut to the beat, to the breath, to the tension between frames." },
        { n: "02", h: "Motion with meaning", t: "Every movement carries intent. Animation is not decoration — it is direction, emotion and voice." },
        { n: "03", h: "Craft over templates", t: "No presets, no shortcuts. Each project earns its own visual language, built frame by frame." },
      ],
      bio: "For over six years I've helped brands and artists turn raw footage and ideas into stories that stop the scroll. From kinetic identities to cinematic edits, I obsess over pacing, contrast and the small details that make work feel alive.",
      statsLabels: { projects: "Projects delivered", years: "Years crafting", clients: "Happy clients" },
    },
    contact: {
      label: "Contact",
      title: "Let's make your brand move",
      intro: "Have a project, a reel to cut, or a brand to bring to life? Drop a line.",
      name: "Your name",
      email: "Your email",
      message: "Tell me about your project",
      send: "Send message",
      sending: "Sending...",
      success: "Message sent — I'll be in touch soon.",
      error: "Something went wrong. Please try again.",
      or: "Or reach out directly",
    },
    footer: { rights: "All rights reserved", made: "Designed & edited in-house", backToTop: "Back to top" },
  },
};

const LangContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  useEffect(() => {
    document.documentElement.lang = "en";
  }, []);
  return <LangContext.Provider value={{ t: translations.en }}>{children}</LangContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  return ctx || { t: translations.en };
};
